<template>
  <el-dialog
    title="模板预览"
    :visible="isShow"
    custom-class="temp-style"
    width="1000px"
    :before-close="handleClose"
  >
    <el-main
      v-if="isLoading"
      v-loading="isLoading"
      element-loading-text="模版正在渲染中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    />
    <template v-else>
      <el-row>
        <h4>基础信息</h4>
        <el-form
          ref="formData"
          :inline="false"
          :model="formData"
        >
          <el-col
            v-for="(item, index) in baseMessageList"
            :key="index"
            :span="item.colSpan"
          >
            <el-form-item
              :label="item.fieldDisplayName + ':'"
              :prop="item.propKey"
              label-width="110px"
              :rules="[
                {
                  required: item.attributeType === '输入框' && item.isRequired,
                  message: ''
                }
              ]"
            >
              <el-input
                v-if="item.attributeType === '输入框'"
                disabled
                placeholder="请输入"
              />
              <p v-else>
                {{ formData[item.propKey] }}
              </p>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>

      <div class="flex flex-align product-style">
        <h4>产品信息</h4>
      </div>
      <el-table
        ref="tableDataRef"
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column fixed="left" label="序号" align="left" type="index" />
        <el-table-column
          v-for="(item, index) in productHeaderList"
          :key="index"
          :prop="item.fieldKey"
          :label="item.fieldDisplayName"
          align="left"
          min-width="150"
        >
          <template slot-scope="">
            <el-input
              v-if="item.attributeType === '输入框'"
              placeholder="请输入"
            />
            <span v-else />
          </template>
        </el-table-column>
      </el-table>
    </template>
  </el-dialog>
</template>

<script>
import { parseTime } from '@/libs/util.js';
import { viewTemplate } from '@/API/markManager.js';

export default {
  data () {
    return {
      isShow: false,
      isLoading: false,
      tempId: '',
      formData: {},
      selectList: [],
      baseType: 'markField',
      baseMessageList: [], // 基础信息
      clientInfo: [{}], // 客户信息
      productHeaderList: [], // 产品信息Table头数据
      tableData: [] // 产品信息数据
    };
  },

  methods: {
    initData (id) {
      this.isShow = true;
      this.isLoading = true;
      viewTemplate({
        id: id
      }).then(res => {
        this.isLoading = false;
        const { data, status } = res.data;
        if (status === '200') {
          // 基础信息的处理
          this.baseMessageList = (data.baseMessageList || []).map(item => {
            const val = () => {
              if (item.fieldKey === 'createTime') {
                return parseTime(new Date());
              } else if (item.fieldKey === 'createName') {
                return this.$store.state.user?.userName;
              }
              return item.defaultValue || '';
            };
            this.$set(this.formData, `${this.baseType}${item.fieldOrder}`, val());
            item.propKey = `${this.baseType}${item.fieldOrder}`;
            return {
              ...item,
              colSpan: ['remark'].indexOf(item.fieldKey) > -1 ? 24 : 8
            };
          });

          // 产品信息的 Table Header头数据处理
          this.productHeaderList = data.productHeaderList || [];

          // 产品信息的 Table 表格数据处理
          this.tableData = data.productDefaultValueList || [];
          this.isLoading = false;
        }
      }).catch(e => {
        this.isLoading = false;
      });
    },

    handleClose () {
      this.isShow = false;
    }
  }
};
</script>

<style lang="scss">
.temp-style {
  .el-dialog__body {
    padding: 20px !important;
    min-height: 300px !important;
  }
  .el-main {
    min-height: 300px !important;
  }
}
</style>

<style lang="scss" scoped>
.temp-style {
  .flex {
    display: flex;
  }
  .flex-align {
    align-items: center;
  }
  .flex-1 {
    flex: 1;
  }
  .el-col {
    height: 40px;
  }
  h4 {
    margin: 10px 0;
  }
  .product-style {
    margin: 12px 0;
    .btn-style {
      margin-left: 20px;
    }
  }
}
</style>
